/**
 * Mutation debounce for Supabase Realtime.
 *
 * When a local mutation runs, its own RTK Query `invalidatesTags` already
 * refetches the affected data. The realtime subscription then receives the
 * echo of that same DB change and would trigger a second, redundant fetch.
 * `markMutationFired()` records the moment of a local mutation;
 * `isRealtimeDebounced()` tells the realtime handler to skip the echo for a
 * short window.
 *
 * Hook-free on purpose: imported by both `useSubstitutionRealtime` (a React
 * hook) and the RTK Query endpoint modules. Keeping it free of React and of
 * the `substitutionApi` import avoids a circular dependency.
 */

let lastMutationTimestamp = 0;
const MUTATION_DEBOUNCE_MS = 1500;

/** Call from mutation handlers to suppress the following realtime echo. */
export function markMutationFired(): void {
  lastMutationTimestamp = Date.now();
}

/** True while a recent local mutation should suppress realtime echoes. */
export function isRealtimeDebounced(): boolean {
  return Date.now() - lastMutationTimestamp < MUTATION_DEBOUNCE_MS;
}
